import { render, staticRenderFns } from "./VehicleCreateView.vue?vue&type=template&id=787e0478&"
import script from "./VehicleCreateView.vue?vue&type=script&lang=ts&"
export * from "./VehicleCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports